import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Constant } from '../../blog/constant';
import { Meta, Title } from '@angular/platform-browser';
import { environment } from '../../../../../environments/environment';
import { EventManagerService } from '../../blog/event-manager.service';
import { HeaderHomePage } from '../../../../common/components/header-home-page/header-home-page';

/**
 * declare Jquery
 * */
declare let $: any;

@Component({
  selector: 'what-is-opened-fund',
  standalone: true,
  imports: [HeaderHomePage],
  templateUrl: './what-is-opened-fund.html',
})
export class WhatisOpenedFundMarketing implements OnInit, OnDestroy {
  parnters: any[] = [];
  public Constant = Constant;
  isScrolled: boolean = false;
  isDevice: boolean = false;
  constructor(
    public meta: Meta, public title: Title, 
    private eventManager: EventManagerService) {}

  ngOnInit() {
    this.setSEOMeta();
    if (typeof window !== 'undefined') {
      $('body').addClass('no-scroll');
    }
  }
  setSEOMeta() {
    this.title.setTitle('Fmarket - Quỹ mở là gì ?');
    this.meta.updateTag({ property: 'og:title', content: 'Fmarket - Quỹ mở là gì ?' });
    this.meta.updateTag({
      property: 'og:description',
      content: `Quỹ mở là gì? Đầu tư chỉ từ 3 ly cà phê.`
    });
    this.meta.updateTag({
      property: 'og:image',
      content: environment.domain + 'assets/params/images/markerting/thumbnail-cafe-quy-mo.png'
    });
    this.meta.updateTag({
      name: 'keywords',
      content: `Fmarket, Quỹ mở là gì ?`
    });
    this.meta.updateTag({ property: 'og:url', content: environment.domain + Constant.path_markerting_what_is_opened_fund });
  }
  ngOnDestroy(): void {
    if (typeof window !== 'undefined') {
      $('body').removeClass('no-scroll');
    }
  }
}
